module.exports = __webpack_public_path__ + "static/media/filter.66623554.svg";